export default {
  // Doesn't use await due to babel-related regenerator issues
  getCart () {
    return fetch('/cart.js')
      .then(response => response.json())
      .catch(console.error)
  },

  // Alert other scripts of a new cart state
  cartUpdated (cart = null) {
    if (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
    } else {
      this.getCart()
        .then((cart) => {
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: cart })
          )
        })
        .catch(console.error)
    }
  },

  // Get info about product using product handle
  getProduct (productHandle) {
    return new Promise((resolve, reject) => {
      fetch(`/products/${productHandle}.js`)
        .then((response) => {
          // console.log('Product info response:', response)
          return response.json()
        })
        .then((data) => {
          // console.log('Product info data:', data)
          resolve(data)
        })
        .catch((err) => {
          console.error('get product info error:', err)
          reject(err)
        })
    })
  },

  // Get product by handle without using a promise
  getUpsellsByHandle (productHandle) {
    return fetch(`/products/${productHandle}?view=upsell-metafields-json`)
      .then(response => response.json())
      .catch(console.error)
  },

  // Add main shopify product and any recommended accessories to cart using ajax POST API
  addProductsToCart (
    products = [{ id: 0, quantity: 1 }],
    openSlideOutCart = true,
    reload = false
  ) {
    this.disableAddToCart()

    // Sarah wants the cart to slide out every time, no matter what device
    // Overriding passed values rather than hunting down everwhere this gets called.
    // Plus, will be easier to undo if we need to. 8/19/2024 DLL
    openSlideOutCart = true

    return new Promise((resolve, reject) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: products
        })
      })
        .then((response) => {
          // console.log('Add to cart data response:', response)
          return response.json()
        })
        .then((data) => {
          // console.log('Add to cart data resolve:', data)

          /* Original from DS plus price adjustments
          // For Tombras: modify Shopify prices to be /100 and add product data to dataLayer before sending to GTM
          const newData = data
          newData.items.forEach((item) => {
            // price fields in data: discounted_price, final_line_price, final_price, original_price, original_line_price, price, line_price
            item.price = item.price / 100
            item.discounted_price = item.discounted_price / 100
            item.final_price = item.final_price / 100
            item.final_line_price = item.final_line_price / 100
            item.line_price = item.line_price / 100
            item.original_price = item.original_price / 100
            item.original_line_price = item.original_line_price / 100
          })
          window.dataLayer.push({ ecommerce: newData })
          window.dataLayer.push({ event: 'AddtoCart' })
          */

          // new per Tombras for setting up data structure according to https://developers.google.com/analytics/devguides/collection/ua/gtm/enhanced-ecommerce#cart
          let currencyCode = 'USD'
          if (window.localeInformation.market === 'canada' || window.localeInformation.currency === 'CAD') {
            currencyCode = 'CAD'
          }
          const newData = {
            currencyCode,
            add: {
              products: []
            }
          }

          data.items.forEach((addedItem) => {
            newData.add.products.push({
              id: addedItem.id,
              name: addedItem.title,
              price: addedItem.price / 100,
              brand: addedItem.vendor,
              category: addedItem.product_type,
              variant: addedItem.variant_title,
              quantity: addedItem.quantity
            })
          })

          // clear previous object
          window.dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'addToCart',
            ecommerce: newData
          })

          /*
          add Klaviyo event
          Klaviyo's code will only allow this if the user already has an identifiable Klaviyo id - that cookie will not be available if declined in Pandectes
           */
          data.items.forEach((addedItem) => {
            // not always getting upsells, though console.log shows it's being sent
            // possibly activity limit on Klaviyo side

            // not using Klaviyo item variable here - has more complete data, but often not the product actually added
            // on PDP page is always the item the PDP is for
            // isn't set on PLP page
            const newItem = {
              Name: addedItem.title,
              ProductID: addedItem.id,
              ImageURL: addedItem.image,
              URL: `${window.location.hostname}${addedItem.url}`,
              Brand: addedItem.vendor,
              Price: `$${addedItem.price / 100} ${window.localeInformation.currency}`,
              $use_ip: true,
              $is_session_activity: true
            }
            // this does not work - apparently the compare at price is not included in data the way it's retrieved above
            // leaving it here in case that changse
            if (addedItem.compare_at_price) {
              newItem.CompareAtPrice = `$${addedItem.compare_at_price / 100} ${window.localeInformation.currency}`
            }

            // this is what sends to event to Klaviyo
            // if pushing inside liquid file we'd be able to add cart info
            // can't do that here, and Klaviyo's own code snippets leave it off in code variants so not worying about it
            // console.log('pushing to learnq in storybook cart-helper', newItem, 'window._learnq', window._learnq)
            // _learnq object might not be available, so test for it
            if (window._learnq) {
              window._learnq.push(['track', 'Added to Cart', newItem])
            }
          })
          /* end Klaviyo event addition */

          /* back to original code */

          // Show cart slide out
          if (openSlideOutCart) {
            document.dispatchEvent(new CustomEvent('cart:show'))
          }

          // Re-enable button
          this.enableAddToCart()

          // Tell places like the slide out cart to update their view
          this.cartUpdated()

          if (reload) {
            location.reload()
          }

          resolve()
        })
        .catch((err) => {
          console.error('Add to cart error:', err)

          // Re-enable button
          this.enableAddToCart()

          reject(err)
        })
    })
  },

  getDefaultVariantID (container = 'section.product-section') {
    return this.getProductData(container, 'data-default-variant-id')
  },

  getProductHandle (container = 'section.product-section') {
    return this.getProductData(container, 'data-product-handle')
  },

  getDefaultVariantPrice (container = 'section.product-section') {
    return this.getProductData(container, 'data-default-variant-price')
  },

  getDefaultVariantComparePrice (container = 'section.product-section') {
    const comparePrice = this.getProductData(
      container,
      'data-default-variant-compare-price'
    )
    return comparePrice || 0
  },

  getGiftCardStatus (container = 'section.product-section') {
    return this.getProductData(container, 'data-gift-card')
  },

  getProductData (container = 'section.product-section', prop) {
    const elem = document.querySelector(`${container} [${prop}]`)
    return elem ? elem.getAttribute(prop) : null
  },

  // Disable add to cart button while request is sending
  disableAddToCart (
    message = window.variantStrings.addingToCart,
    container = 'section.product-section',
    ref = 'addToCartButton'
  ) {
    this.setAddToCartState(true, container, ref, message.toUpperCase())
  },

  // Enable add to cart button after request is sent
  enableAddToCart (
    container = 'section.product-section',
    ref = 'addToCartButton'
  ) {
    const message = window.variantStrings.addToCart.toUpperCase()
    this.setAddToCartState(false, container, ref, message)
  },

  // Look for addToCartButtons inside container selector
  setAddToCartState (
    disabled,
    container = 'section.product-section',
    message = window.variantStrings.addToCart,
    ref = 'addToCartButton'
  ) {
    // NOTE: Not using $refs since ALL add to cart buttons are wanted
    // Specify section.product-section to avoid mini product cards with add-to-cart buttons
    document
      .querySelectorAll(`${container} [ref="${ref}"]`)
      .forEach((button) => {
        const innerElem =
          button.children.length > 0 ? button.children[0] : button
        button.disabled = disabled
        innerElem.innerText = message.toUpperCase()
      })
  }
}
